<template>
  <div style="height:100%;">
    <el-row style="height:55px;">
      <tool-bar @add="add" @search="search" :deletelist="selectdList"></tool-bar>
    </el-row>
    <el-row style="height:calc(100% - 55px - 42px);">
      <el-table :data="data" border :height="700" style="width: 100%" height="100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column fixed prop="name" label="电台" width="330">
        </el-table-column>
        <el-table-column prop="frequency" label="频率" width="100">
        </el-table-column>
        <el-table-column prop="area" label="地区" width="150" :filters="areas" :filter-method="filterTag">
        </el-table-column>
        <el-table-column label="运行时段">
          <template slot-scope="scope">
            <el-tag v-for="(time,i) in scope.row.runtime" :key="i" v-if="time.length>0">
              {{PraseWeekday(i)}}
              <el-tag type="warning" size="small">{{PraseHour(time)}}</el-tag>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.$index)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="height:42px;padding-top:10px;">
      <PageNation ref='pageNation' @change="pageChange"></PageNation>
    </el-row>

    <edit ref='edit' :data='data[selectd_index]' @save="updata"></edit>
  </div>
</template>

<script>
  import Edit from "@/components/WhiteList/Edit";
  import PageNation from "@/components/WhiteList/PageNation";
  import ToolBar from "@/components/WhiteList/ToolBar";
  export default {
    mounted() {
      this.SearchForDatas();
    },
    components: {
      Edit,
      PageNation,
      ToolBar
    },
    methods: {
      handleSelectionChange(a) {
        let ids = [];
        for (let i = 0; i < a.length; i++) {
          const element = a[i];
          ids.push(element.id);
        }
        this.selectdList = ids
      },
      add(data) {
        this.data.unshift(data);
      },
      filterTag(a, b, c, d) {
        if (b.area == a) {
          return true;
        } else {
          return false;
        }
      },
      pageChange(e) {
        this.SearchForDatas(this.keywords);
      },
      search(keywords) {
        this.keywords = keywords;
        this.$refs["pageNation"].getTotalsize(keywords);
        this.SearchForDatas(keywords);
      },
      SearchForDatas(keywords) {
        if (!keywords) keywords = "";
        this.$getJSON("/radio/s_whitelst", {
          rows_per_page: this.$refs["pageNation"].size,
          current_page: this.$refs["pageNation"].page,
          keywords: keywords
        }).then(res => {
          let areas_map = {};
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            areas_map[element.area] = {
              text: element.area,
              value: element.area
            };
          }
          let areas = [];
          for (let area in areas_map) {
            areas.push(areas_map[area]);
          }
          this.areas = areas;
          this.data = res.data;
        });
      },
      updata(data) {
        for (var key in data) {
          this.data[this.selectd_index][key] = data[key];
        }
      },
      PraseWeekday(i) {
        switch (i * 1) {
          case 1:
            return "周一";
          case 2:
            return "周二";
          case 3:
            return "周三";
          case 4:
            return "周四";
          case 5:
            return "周五";
          case 6:
            return "周六";
          case 7:
            return "周日";
        }
      },
      PraseHour(array) {
        let result = "";
        for (let i = 0; i < array.length; i++) {
          const element = array[i];
          if (i == 0) {
            result += element;
          } else if (i == array.length - 1) {
            result += `~${element}`;
          } else if (element + 1 < array[i + 1]) {
            result += `~${element} ${element}`;
          }
        }
        return result;
      },
      edit(index) {
        this.selectd_index = index;
        this.$refs["edit"].show();
      }
    },
    data() {
      return {
        selectd_index: "",
        areas: [],
        data: [],
        selectdList: []
      };
    }
  };

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WhiteList/Table.vue